




























































































































import {Component, Vue} from 'vue-property-decorator';
import {ObjectFactory} from '../../config/objectFactory';
import {email, minLength, required} from 'vuelidate/lib/validators';
import {MedTransGoConstants} from '../../util/constants';
import {MapUtils} from '@/util/mapUtils';
import {Address, ApiRequest, CreateRideCreditProfileRequest, UpdateRideCreditProfileRequest} from '@/types/request';
import {CommonUtils} from '@/util/commonUtils';
import {EventBus} from '@/main';
import {Patient, RideCreditProfile} from '@/types/entity';
import {ToastEvent} from '@/types/event';

declare var google: any;

@Component({
    props: {
        editProfile: {
            type: Boolean,
            default: false,
            required: false,
        },
        profileDetails: {
            type: Object,
            required: false,
            default: null,
        },
    },
    validations: {
        firstName: {
            required,
            regex: (value) => /^[a-zA-Z ]+$/.test(value),
        },
        lastName: {
            required,
            regex: (value) => /^[a-zA-Z ]+$/.test(value),
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            minLength: minLength(10),
        },
        billingLocationId: {
            required,
        },
        selectedFacilities: {
            required: (value) => value.length > 0,
        },
    },
})
export default class AddRideCreditProfileModal extends Vue {
    private firstName = '';
    private lastName = '';
    private email = '';
    private phone = '';
    private providersOptions: any[] = [];
    private patientAddresses: any[] = [{ fullAddress: '', zip: '' }];
    private selectedFacilities: [{
        id?: string;
        fullname: string;
        email: string;
        address: Address;
    }] = [] as any;
    private locationOptions: any[] = [];
    private billingLocationId = '';
    private show = false;
    private errorMessage = '';
    private isFormValid = false;
    private selectedFacilityId = '';
    private patients: Patient[] = [];
    private selectedPatientId = '';

    private async mounted() {
        if (this.$props.editProfile && this.$props.profileDetails) {
            const profileDetails: RideCreditProfile = this.$props.profileDetails;
            const namesArray = profileDetails.patient.fullName.split(' ');
            const firstName = namesArray[0];
            const lastName = namesArray[1];
            this.firstName = firstName;
            this.lastName = lastName;
            this.email = profileDetails.patient.email;
            this.phone = profileDetails.patient.phone;
            this.selectedFacilities = profileDetails.facility;
            this.billingLocationId = profileDetails.billingLocation;
            this.patientAddresses = profileDetails.patient.addresses;
        }
        this.show = true;
        await this.getBillingLocations();
        this.getPatients();
        this.getHealthcareProviders();
        this.setupGoogleAutocomplete(0);
        this.validateForm();
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
        replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
        .getHealthcareProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        if (response.data) {
        this.providersOptions = response.data;
        }
    }

    private async getBillingLocations() {
        const locations = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (locations.success && locations.data) {
            this.locationOptions = locations.data.map((location: any) => ({
                value: location.id,
                text: location.locationName,
            }));
        }
    }

    private validateForm() {
        let isAddressEntered = true;
        this.patientAddresses.forEach((address: Address) => {
            if (!address.fullAddress || !address.zip || !address.latitude || !address.longitude) {
                isAddressEntered = false;
                return;
            }
        });
        this.isFormValid =  !this.$v.$invalid && isAddressEntered;
    }

    private close() {
        this.$emit('close');
        this.show = false;
    }

    private async createRideCreditProfile() {
        const createProfileRequest: CreateRideCreditProfileRequest = {
            patient: {
                fullName: `${this.firstName} ${this.lastName}`,
                addresses: this.patientAddresses,
                email: this.email,
                phone: this.phone,
            },
            billingLocation: this.billingLocationId,
            facility: this.selectedFacilities,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/rideCredit/createProfile`,
            data: createProfileRequest,
            loaderEvent: { show: true },
        };
        const response = await ObjectFactory.getHttpService().post<any>(apiRequest);
        if (response.success) {
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, {
                message: 'Pass Profile Created Successfully.',
                title: 'Success',
                variant: 'success',
                timeout: 5000,
            });
            this.close();
        } else {
            this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, {
                message: this.errorMessage,
                title: 'Error',
                variant: 'danger',
                timeout: 5000,
            });
        }
    }

    private addAddress() {
        this.patientAddresses.push({ fullAddress: '', zip: '' });
        this.$nextTick(() => {
            this.setupGoogleAutocomplete(this.patientAddresses.length - 1);
            this.validateForm();
        });
    }

    private removeAddress(index: number) {
        if (this.patientAddresses.length > 1) {
            this.patientAddresses.splice(index, 1);
            this.validateForm();
        }
    }

    private setupGoogleAutocomplete(index: number) {
        this.$nextTick(() => {
        const inputId = `patientAddress_${index}`;
        const inputElement = document.getElementById(inputId);
        if (inputElement) {
            const autocomplete = new google.maps.places.Autocomplete(inputElement, { types: ['geocode'] });
            autocomplete.addListener('place_changed', () => {
                this.patientAddresses[index] = MapUtils.parseGoogleAddress(autocomplete);
                this.validateForm();
            });
        }
        });
    }

    private addFacility(event: any) {
        const selectedFacilityId = this.selectedFacilityId;
        const healthcareFacilityIndex =
            this.providersOptions.findIndex((facility) => facility.id === selectedFacilityId);

        if (healthcareFacilityIndex !== -1) {
            const healthcareFacility = this.providersOptions[healthcareFacilityIndex];
            if (!this.selectedFacilities.some((selected) => selected.id === healthcareFacility.id)) {
                const { id: facilityId, fullname: facilityFullname, email: facilityEmail, address: facilityAddress }
                    = healthcareFacility;
                this.selectedFacilities.push
                    ({ id: facilityId, fullname: facilityFullname, email: facilityEmail, address: facilityAddress });
                this.providersOptions.splice(healthcareFacilityIndex, 1);
            }
        }
        this.selectedFacilityId = '';
        this.validateForm();
    }

    private removeFacility(facility: any) {
        const facilityIndex = this.selectedFacilities.findIndex((selected) => selected.id === facility.id);

        if (facilityIndex !== -1) {
            const removedFacility = this.selectedFacilities[facilityIndex];
            this.selectedFacilities.splice(facilityIndex, 1);
            this.providersOptions.push(removedFacility);
        }

        this.validateForm();
    }

    private async updateRideCreditProfile() {
        const iHttpService = ObjectFactory.getHttpService();
        const updateProfileAddressRequest: UpdateRideCreditProfileRequest = {
            id: this.$props.profileDetails.id,
            facility: this.selectedFacilities,
            patient: {
                addresses: this.patientAddresses,
                email: this.email,
                fullName: this.firstName + ' ' + this.lastName,
                phone: this.phone,
            },
            billingLocation: this.billingLocationId,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/rideCredit/update`,
            data: updateProfileAddressRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Profile Updated Successfully.',
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getPatients() {
        const response = await ObjectFactory.getPatientService()
            .getPatientList(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.patients = response.data as any;
    }

    private setPatientDetails() {
        if (this.selectedPatientId) {
            const patientDetails = this.patients.find((patient) => patient.id === this.selectedPatientId);
            if (patientDetails) {
                if (patientDetails.fullName) {
                    const nameParts = patientDetails.fullName.split(' ');
                    if (nameParts.length >= 2) {
                        this.firstName = nameParts[0];
                        this.lastName = nameParts.slice(1).join(' ');
                    }
                }
                this.phone = patientDetails.phone ? patientDetails.phone : '';
                if (patientDetails.location) {
                    const location = this.locationOptions.find((obj) => obj.text === patientDetails.location);
                    if (location) {
                        this.billingLocationId = location.value;
                    }
                }
                if (patientDetails.address) {
                    this.patientAddresses[0] = patientDetails.address;
                }
                if (patientDetails.email) {
                    this.email = patientDetails.email;
                }
            }
        }
    }
}
